import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemCard from './ItemCard';
import { Card, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import NoDataLayer from '../../../../../Common/NoDataLayer';
import HEADER_TOOLBAR from '../HEADER_TOOLBAR';
import moment from 'moment';
import { isNullUndefinedOrEmpty } from '../../../../../../common/Helpers';

const ELEMENT_KPI_COMMENT_EVENT = (props) => {
    const { 
        inputParam_HideHeader = false,
        inputParam_BoardStructure = null,
        inputParam_Container = null,
        inputParam_ComponentContent = null,
        inputParam_UseFake = false,
    } = props;

    const { t } = useTranslation();
    
    const [data, setData] = useState(!inputParam_UseFake ? (!isNullUndefinedOrEmpty(inputParam_ComponentContent) && !isNullUndefinedOrEmpty(inputParam_ComponentContent.items) ? inputParam_ComponentContent.items.map(x => (
        {
            title: x.eventName,
            text: x.variableName,
            date: moment(x.eventDate).format('YYYY/MM/DD'),
            iconName: x.eventTypeId === 6 ? "FieldNotChanged" : "PaymentCard",
            iconColor: "white",
            circleColor: x.eventTypeId === 6 ? "grey" : "#D39128",
            username: x.eventUsername
        }
    )) : []) : [{
        title: 'Evento',
        text: 'Nombre variable',
        date: '2024/01/05',
        iconName: "PaymentCard",
        iconColor: "white",
        circleColor: "#D39128",
        username: "Nombre usuario"
    },{
        title: 'Evento',
        text: 'Nombre variable',
        date: '2024/01/17',
        iconName: "FieldNotChanged",
        iconColor: "white",
        circleColor: "grey",
        username: "Nombre usuario"
    }]);

    const renderContent = () => {
        return <>
        {
            data !== null && data.length > 0 ?
            <>
                {
                    data.map((card, index) => (
                        <Row key={index} className={`${index === 0 ? "" : "pt-2 border-top"} mb-2`} style={{opacity: inputParam_UseFake ? ".4" : ""}}>
                            <ItemCard inputParam_Object={card}/>
                        </Row>
                    ))
                }
            </> : <NoDataLayer display={true}/>
        }
        </>
    }

    return (<div className='h-100'> 
                {
                    !inputParam_UseFake &&
                    <Card className='round h-100'>
                        {
                            !inputParam_HideHeader &&
                            <Card.Header className="card-header-compact">
                                <Card.Title className="d-flex justify-content-between">
                                    <b>{ inputParam_ComponentContent !== null ? (inputParam_ComponentContent.boardComponentTitle ?? t('data-lang-boxname-eventscomments')) : t('data-lang-boxname-eventscomments')}</b>
                                    <div className='toolbar d-flex'>
                                        <HEADER_TOOLBAR
                                            inputParam_BoardStructure={inputParam_BoardStructure}
                                            inputParam_Container={inputParam_Container}
                                        />
                                    </div>
                                </Card.Title>
                            </Card.Header>
                        }
                        <Card.Body className='p-1' style={{overflowY: "scroll", overflowX: "hidden"}}>
                            {renderContent()}
                        </Card.Body>
                    </Card>
                }            
                {
                    inputParam_UseFake && renderContent()
                }
            </div>
    );
};

ELEMENT_KPI_COMMENT_EVENT.propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_BoardStructure: PropTypes.object,
    inputParam_Container: PropTypes.object,
    inputParam_ComponentContent: PropTypes.object,
    inputParam_UseFake: PropTypes.bool,
};

export default ELEMENT_KPI_COMMENT_EVENT;